import { FirebaseError } from '../../../types/errors'

interface SignUpValidation {
  isValid: boolean
  error?: string
}

const validateSignUpForm = (
  email: string,
  password: string,
  confirmPassword: string,
): SignUpValidation => {
  if (!email || !password || !confirmPassword) {
    return {
      isValid: false,
      error: 'Please fill in all required fields',
    }
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return {
      isValid: false,
      error: 'Please enter a valid email address',
    }
  }

  if (password !== confirmPassword) {
    return {
      isValid: false,
      error: 'Passwords do not match',
    }
  }

  if (password.length < 6) {
    return {
      isValid: false,
      error: 'Password must be at least 6 characters',
    }
  }

  // Check for password strength (optional enhancement)
  const hasUpperCase = /[A-Z]/.test(password)
  const hasLowerCase = /[a-z]/.test(password)
  const hasNumbers = /\d/.test(password)

  if (!(hasUpperCase && hasLowerCase && hasNumbers)) {
    return {
      isValid: false,
      error: 'Password should contain uppercase, lowercase and numbers',
    }
  }

  return { isValid: true }
}

const getErrorMessage = (error: FirebaseError): string => {
  // Firebase error handling
  if (error.code) {
    switch (error.code) {
      case 'auth/email-already-in-use':
        return 'An account with this email already exists'
      case 'auth/invalid-email':
        return 'Invalid email address'
      case 'auth/operation-not-allowed':
        return 'Sign up is currently disabled'
      case 'auth/weak-password':
        return 'Password is too weak. Please use a stronger password'
      default:
        return error.message || 'Failed to create account'
    }
  }

  return error.message || 'Failed to create account'
}

export { validateSignUpForm, getErrorMessage }
